import requester from '@/lib/axios';
import {
  ActivityGenerate,
  ActivityInput,
} from '@/models/astro.ai/generate/Activity';
import { ImageGenerate, ImageInput } from '@/models/astro.ai/generate/Image';
import {
  LessonBlocksGenerate,
  LessonBlocksInput,
} from '@/models/astro.ai/generate/LessonBlock';
import {
  LessonMatrixGenerate,
  LessonMatrixInput,
} from '@/models/astro.ai/generate/LessonMatrix';
import ObjectivesGenerate, {
  ObjectiveInput,
} from '@/models/astro.ai/generate/Objective';
import Chapter from '@/models/Chapter';

const baseUrl = 'astro-ai';

export const activityGenerator = async (
  generatePayload: ActivityInput,
  signal?: AbortSignal,
): Promise<ActivityGenerate> => {
  const { data } = await requester().post<ActivityGenerate>(
    `${baseUrl}/activity/`,
    generatePayload,
    { signal },
  );

  return data;
};

export const objectivesGenerator = async (
  generatePayload: ObjectiveInput,
  signal?: AbortSignal,
): Promise<ObjectivesGenerate> => {
  const { data } = await requester().post<ObjectivesGenerate>(
    `${baseUrl}/objective/`,
    generatePayload,
    { signal },
  );

  return data;
};

export const lessonBlocksGenerator = async (
  generatePayload: LessonBlocksInput,
  signal?: AbortSignal,
): Promise<LessonBlocksGenerate> => {
  const { data } = await requester().post<LessonBlocksGenerate>(
    `${baseUrl}/lesson-block/`,
    generatePayload,
    { signal },
  );

  return data;
};

export const imageGenerationGenerator = async (
  generatePayload: ImageInput,
  signal?: AbortSignal,
): Promise<ImageGenerate> => {
  const { data } = await requester().post<ImageGenerate>(
    `${baseUrl}/image-generation/`,
    generatePayload,
    { signal },
  );

  return data;
};
export const lessonMatrixGenerator = async (
  generatePayload: LessonMatrixInput,
  signal?: AbortSignal,
): Promise<LessonMatrixGenerate> => {
  const { data } = await requester().post<LessonMatrixGenerate>(
    `${baseUrl}/lesson-matrix/`,
    generatePayload,
    { signal },
  );

  return data;
};

type GenerateChapterParams = {
  order?: number;
  title?: string;
  lessonId: number;
};

export const generateChapterContent = async (
  body: GenerateChapterParams,
): Promise<Omit<Chapter, 'id' | 'book'>> => {
  const { data: chapter } = await requester().post<Chapter>(
    `astro-ai/chapter-content/`,
    body,
  );

  return chapter;
};
